import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../components/footer/footer';

const Layout: React.FC = () => {
  return (
    <>
       {/*  <NavBar />*/}
        <Outlet />
        <Footer />
    </>
  );
};

export default Layout;
